<template>
  <div v-if="!isMobile">
    <ms-sider-bar :is-title="isTitle" :list="list" @menu-click="handleMenuClick" :menuId="$route.params.menuId"></ms-sider-bar>
  </div>
  <div class="mobile-side-bar" v-else>
    <div class="el-icon-s-unfold" @click="drawer = true"></div>
    <el-drawer
      :size="236"
      :append-to-body="true"
      :with-header="false"
      :visible.sync="drawer"
      direction="ltr"
      custom-class="custom-drawer"
      :before-close="handleDrawerClose">
      <ms-sider-bar :is-title="isTitle" :list="list" @menu-click="handleMenuClick" :menuId="$route.params.menuId"></ms-sider-bar>
    </el-drawer>
  </div>
</template>

<script>
import MsSiderBar from './MsSiderBar.vue'
export default {
  name: 'MsSiderBarBox',
  components: { MsSiderBar },
  props: {
    isTitle: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      drawer: false
    }
  },
  methods: {
    handleMenuClick(data) {
      console.log(data)
      this.drawer = false
      this.$emit('menu-click', data)
    },
    handleDrawerClose() {
      this.drawer = false
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-side-bar {
  position: fixed;
  top: 165px;
  left: 15px;
  z-index: 22;
  .el-icon-s-unfold {
    font-size: 40px;
    color: #005EFF;
  }
}
</style>